export type MapPitchMode = '2d' | '3d'
export type MapStyleMode = 'standard' | 'satellite'
export type MapLightPreset = 'dawn' | 'day' | 'dusk' | 'night'

export const MAP_FLAT_CAMERA = { pitch: 0, bearing: 0 } as const
export const CITY_VIEW_3D_CAMERA = { pitch: 60, bearing: 0 } as const

export const DEFAULT_MAP_STYLE_MODE: MapStyleMode = 'standard'
export const DEFAULT_MAP_LIGHT_PRESET: MapLightPreset = 'day'
export const MAPBOX_STANDARD_STYLE = 'mapbox://styles/mapbox/standard'
export const MAPBOX_SATELLITE_STYLE = 'mapbox://styles/mapbox/standard-satellite'
export const MAPBOX_STANDARD_BASEMAP_CONFIG = {
  show3dObjects: true,
  show3dBuildings: true,
  show3dFacades: true,
  show3dLandmarks: true,
  show3dTrees: true,
} as const

export const MAPBOX_TERRAIN_SOURCE_ID = 'mapbox-dem'
export const MAPBOX_TERRAIN_SOURCE = {
  type: 'raster-dem',
  url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
  tileSize: 512,
  maxzoom: 14,
} as const
export const MAPBOX_TERRAIN = { source: MAPBOX_TERRAIN_SOURCE_ID, exaggeration: 1.2 } as const

export function getMapPitchCamera(mode: MapPitchMode) {
  return mode === '3d' ? CITY_VIEW_3D_CAMERA : MAP_FLAT_CAMERA
}

export function getPitchModeFromPitch(pitch: number): MapPitchMode {
  return pitch >= 10 ? '3d' : '2d'
}

export function getMapboxStyle(mode: MapStyleMode) {
  return mode === 'satellite' ? MAPBOX_SATELLITE_STYLE : MAPBOX_STANDARD_STYLE
}

export function getMapboxConfig(lightPreset: MapLightPreset = DEFAULT_MAP_LIGHT_PRESET) {
  return {
    basemap: {
      lightPreset,
      ...MAPBOX_STANDARD_BASEMAP_CONFIG,
    },
  } as const
}
